import React from 'react';

import { Box, Flex, Text } from '@mantine/core';

import { LIABILITY_SEVERITY } from '../antibody-analysis/utilities/liabilityBadge';
import { SHM_COLOR_SCALE } from '../colors';
import { ColorMapBy } from '../store/slices/clonotypes.slice';

/**
 * Compact swatch strip for the "Color by" modes (SSTSW-951).
 * The categorical modes (Ig isotype, clonotype ID) are self-explanatory
 * from the per-node tooltip, but SHM is intensity based and liabilities are a severity
 * ordering — neither can be read without seeing the scale.
 */

const SCALES: Partial<Record<ColorMapBy, ReadonlyArray<{ key: string; label: string; color: string }>>> = {
  [ColorMapBy.SHM]: SHM_COLOR_SCALE,
  [ColorMapBy.LIABILITY]: LIABILITY_SEVERITY,
};

export function NetworkMapColorLegend({ colorMapBy }: { colorMapBy: ColorMapBy | null }) {
  const scale = colorMapBy ? SCALES[colorMapBy] : undefined;
  if (!scale) {
    return null;
  }

  return (
    <Flex align="center" gap={2} data-testid="network-map-color-legend">
      {scale.map((entry) => (
        <Flex key={entry.key} align="center" gap={4} pr={6}>
          <Box w={10} h={10} bg={entry.color} style={{ borderRadius: '50%', border: '0.5px solid rgba(0,0,0,0.2)' }} />
          <Text size="xs" c="dimmed">
            {entry.label}
          </Text>
        </Flex>
      ))}
    </Flex>
  );
}
